import { forwardRef } from 'react';

/**
 * HudCard — carte/panneau standard du design system Cockpit.
 *
 * Variants:
 *   - 'glass' (default): surface translucide subtile + border faible, hover lift
 *   - 'flat'           : surface plate sans hover
 *   - 'raised'         : panneau opaque avec ombre cockpit
 *
 * Props:
 *   - bracket: bool — affiche les coins crosshair gold (cockpit accent)
 *   - highlight: bool — bordure gold + glow (état important)
 *   - className: string
 *   - as: 'div' | 'section' | 'article' | etc.
 */
const HudCard = forwardRef(function HudCard(
  { variant = 'glass', bracket = false, highlight = false, glass = true,
    as: Tag = 'div', className = '', children, ...rest },
  ref
) {
  const variantClass =
    variant === 'raised' ? 'hud-card hud-card-raised'
    : variant === 'flat' ? 'hud-card'
    : 'hud-card hud-card-glass';

  const cls = [
    variantClass,
    bracket ? 'hud-bracket' : '',
    highlight ? 'hud-card-highlight' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag ref={ref} className={cls} {...rest}>
      {children}
      {bracket && (
        <>
          <span className="hud-bracket-bl" />
          <span className="hud-bracket-br" />
        </>
      )}
    </Tag>
  );
});

export default HudCard;
export { HudCard };
